module.exports = __webpack_public_path__ + "static/media/error.9f817ef6.jpg";